import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "react-toastify";
import {
  createMeetingNotesTemplate,
  updateMeetingNotesTemplate,
} from "../api/meetingNotesTemplates";

// Creates a new template, or updates an existing one when an id is passed in.
export const useSaveMeetingNotesTemplate = (onSuccess) => {
  const queryClient = useQueryClient();
  const [formErrors, setFormErrors] = useState({});

  const { mutate: saveMeetingNotesTemplateMutate, isLoading } = useMutation({
    mutationFn: ({ id, name, instructions }) => {
      const data = { name, instructions };
      return id
        ? updateMeetingNotesTemplate(id, data)
        : createMeetingNotesTemplate(data);
    },
    onSuccess: (response) => {
      setFormErrors({});
      queryClient.invalidateQueries({
        queryKey: ["meeting-notes-templates"],
      });
      toast.success("Template saved");
      onSuccess?.(response?.data?.data);
    },
    onError: (error) => {
      if (error?.response?.status === 422) {
        const errors = error?.response?.data?.errors ?? {};
        const message = error?.response?.data?.message ?? null;
        setFormErrors(errors);
        if (Object.keys(errors).length === 0 && message) {
          toast.error(message);
        }
      } else {
        toast.error("There was a problem saving. Please try again.");
      }
    },
  });

  // Validation errors belong to the template that was being edited, so the
  // screen clears them when the selection changes.
  const resetFormErrors = () => setFormErrors({});

  return {
    saveMeetingNotesTemplateMutate,
    formErrors,
    resetFormErrors,
    isLoading,
  };
};
